document.addEventListener("DOMContentLoaded", function () {

  const url = new URL(window.location.href);

  if (!url.searchParams.has("_kx")) return;
  if (!window.location.pathname.includes("/products/")) return;
  if (sessionStorage.getItem("klaviyo_tracked")) return;

  let tries = 0;

  const interval = setInterval(() => {
    tries++;

    const klaviyoReady = window._learnq && Array.isArray(window._learnq);
    const product = window.ShopifyAnalytics?.meta?.product;

    if (klaviyoReady && product) {
      clearInterval(interval);

      const cleanUrl = window.location.origin + window.location.pathname;

      const params = new URLSearchParams(window.location.search);
      const variantIdFromUrl = params.get("variant");

      const variant =
        product.variants.find(v => v.id == variantIdFromUrl) ||
        product.variants.find(v => v.id == product.selectedVariantId) ||
        product.variants[0];

      // Name: aus variant.name (vor " - ")
      const nameFromVariant = (variant?.name || "").split(" - ")[0];

      // Image: OG-Image
      const ogImage = document.querySelector('meta[property="og:image"]');
      let imageUrl = ogImage ? ogImage.content : null;
      if (imageUrl) imageUrl = imageUrl.replace("http://", "https://");

      const priceNumber = (variant?.price || 0) / 100;
      const compareAtNumber = (variant?.compareAtPrice || 0) / 100;

      // exakt: €12,34
      const euro = (n) => "€" + n.toFixed(2).replace(".", ",");
      // exakt: 12,34 (ohne €)
      const euroPlain = (n) => n.toFixed(2).replace(".", ",");

      const payload = {
        Categories: product.type || "",
        Brand: product.vendor || "",
        ImageURL: imageUrl,
        CompareAtPrice: euro(compareAtNumber),
        URL: cleanUrl,
        Price: euro(priceNumber),
        ProductID: product.id,
        Name: nameFromVariant,
        Value: euroPlain(priceNumber),
        source: "email_click",

        // sorgt dafür, dass Klaviyo nicht "$value: 0" dranhängt
        $value: priceNumber
      };

      window._learnq.push(["track", "NL Product Viewed", payload]);

      sessionStorage.setItem("klaviyo_tracked", "true");
    }

    if (tries > 40) {
      clearInterval(interval);
    }

  }, 150);

});